import { FormControl, FormLabel, Select } from '@frontend/legacy-components';

import {
  QUOTE_ITEM_STATUS as WORKFLOW_STATUS,
  QUOTE_ITEM_STATUS_LABEL as WORKFLOW_STATUS_LABELS,
} from 'constants/all';

import { SelectorOption } from '../data/types';

const WORKFLOW_STATUSES = [
  WORKFLOW_STATUS.NOT_STARTED,
  WORKFLOW_STATUS.IN_PROGRESS,
  WORKFLOW_STATUS.ON_HOLD,
  WORKFLOW_STATUS.COMPLETED,
];

export const WorkflowStatusSelect = ({
  onChange,
  value,
}: {
  onChange: any;
  value: SelectorOption | undefined;
}) => {
  const workflowStatuses = WORKFLOW_STATUSES.map((status) => ({
    label: WORKFLOW_STATUS_LABELS[status],
    value: status,
  }));
  const noQuoteStatus = [
    {
      label: WORKFLOW_STATUS_LABELS[WORKFLOW_STATUS.NO_QUOTE],
      value: WORKFLOW_STATUS.NO_QUOTE,
    },
  ];
  const workflowStatusSelectOptions = [
    {
      options: workflowStatuses,
    },
    {
      options: noQuoteStatus,
    },
  ];

  return (
    <FormControl>
      <FormLabel>Workflow Status</FormLabel>
      <Select
        placeholder="Don't change"
        onChange={onChange}
        options={workflowStatusSelectOptions}
        value={value}
      />
    </FormControl>
  );
};

export default WorkflowStatusSelect;
